function getAffiliateURL(tokenId) {
  return `${process.env.REACT_APP_PERTIX_URL}/?affiliate=${tokenId}`;
}

const affiliateHelpers = {
  getAffiliateURL,
};

export default affiliateHelpers;
